<div class="account-pages"></div>
<div class="clearfix"></div>

<div class="wrapper-page">
	<div class="ex-page-content text-center">
		<div class="text-error">
			<span class="text-primary">4</span>
			<i class="fa fa-frown-o text-pink"></i>
			<span class="text-info">4</span>
		</div>
		<h2>{{TR "Seite nicht gefunden"}}</h2>
		<br>
		<p class="text-muted">
			{{TR "Diese Seite konnte nicht gefunden werden oder wurde entfernt."}}
		</p>
		<br>
		<a class="btn btn-default" href="#">
			{{TR "Zurück zur Startseite"}}
		</a>
	</div>
</div>
